import { configureStore } from '@reduxjs/toolkit';
import formReducer from '../slices/formSlice';
import orariReducer from '../slices/orariSlice';
import serviziReducer from '../slices/serviziSlice';
import poltroneReducer from '../slices/poltroneSlice';

const store = configureStore({
  reducer: {
    form: formReducer,
    orari: orariReducer,
    servizi: serviziReducer,
    poltrone: poltroneReducer,
  },
});

export default store;
